import { useQuery } from "@tanstack/react-query";
import { Button, DatePicker, Modal, Spin } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/en"; // assuming you're using English
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { useState } from "react";
import { CiEdit } from "react-icons/ci";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { MdAdd } from "react-icons/md";
import { useParams } from "react-router-dom";
import {
  getClosePeriodSalonTeamMember,
  getTimeOffAdmin,
  getWorkingsHourTeamMember,
} from "../../../network/admin";
import { teamMember } from "../../../types/calendar";
import { modalTypes } from "../../../types/workingHoure";
import { getDaysOfWeek } from "../../../utils/DateUtils";
import AddAdditionalShift from "../../teamMember/workingHours/AddAdditionalShift";
import { workingHour } from "../../teamMember/workingHours/CalendarBody";
import DeleteTimeOff from "../../teamMember/workingHours/DeleteTimeOff";
import DeleteWorkingShift from "../../teamMember/workingHours/DeleteWorkingShift";
import AddBreakForm from "../../teamMember/workingHours/addShift/AddBreakForm";
import Main from "../../teamMember/workingHours/addShift/Main";
import DayWorkingHours from "./DayWorkingHours";
import TeamMemberVacation from "./TeamMemberVacation";
dayjs.extend(isBetween);

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
type Props = { data: any; teamMember: teamMember; locationDetails: any };
dayjs.locale("en");
const TeamMemberWorkingHours = ({
  data,
  teamMember,
  locationDetails,
}: Props) => {
  const locationId: any = useParams()?.salonName;

  const [activeModal, setActiveModal] = useState<modalTypes | null>(null);
  const [selectedDate, setSelectedDate] = useState<any>(dayjs());
  const [selectedDay, setSelectedDay] = useState<string | null>(null);
  const [selectedShiftIdOrDate, setSelectedShiftIdOrDate] = useState<
    number | string | null
  >(null);
  //
  const [formatedWorkingHours, setFormatedWorkingHours] = useState<
    Array<workingHour | null>
  >([]);

  const handleOpenModalToAddToShift = (
    shiftId: number,
    modalType: modalTypes
  ) => {
    setSelectedShiftIdOrDate(shiftId);
    setActiveModal(modalType);
  };
  const onChangeDatePicker = (value: any) => {
    setSelectedDate(new Date(value?.format("YYYY-MM-DD") || ""));
  };

  const changeDate = (changeType: "next" | "prev") => {
    const newDate = new Date(selectedDate);
    if (changeType === "next") {
      newDate.setDate(selectedDate.getDate() + 7);
    } else if (changeType === "prev") {
      newDate.setDate(selectedDate.getDate() - 7);
    }
    setSelectedDate(newDate);
  };

  const closeModal = () => {
    setActiveModal(null);
    setSelectedDay(null);
    setSelectedShiftIdOrDate(null);
  };
  const openModal = (modal: any, day: string | null = null) => {
    setSelectedDay(day);
    setActiveModal(modal);
  };
  const { data: TeamMemberWorkingsHour, isLoading } = useQuery(
    ["TeamMember", selectedDate],
    () =>
      locationId &&
      getWorkingsHourTeamMember(+locationId, teamMember?.id, {
        start_date: dayjs(selectedDate).format("YYYY-MM-DD"),
        end_date: dayjs(selectedDate)
          .endOf("week")
          .add(1, "day")
          .format("YYYY-MM-DD"),
      }),
    {
      enabled: !!locationId && !!teamMember?.id,
    }
  );
  const { data: SalonCLosePeriodDate, isLoading: isCLoseLoading } = useQuery(
    ["CLosePeriod", selectedDate],
    () =>
      locationId &&
      getClosePeriodSalonTeamMember(teamMember?.locations[0]?.salon_id),
    {
      select: (res) => {
        console.log(res?.data?.data);
        const activeLocationClosedPeriods = res?.data?.data?.filter(
          (closedPeriod: any) => {
            console.log(closedPeriod?.locations, locationId);

            return (
              closedPeriod?.locations?.find(
                (loc: any) => +loc.id === +locationId
              ) !== undefined
            );
          }
        );

        return activeLocationClosedPeriods;
      },
    }
  );

  const { data: GetTimeOffAdmin, isLoading: isVacationLoading } = useQuery(
    ["vacation", selectedDate],
    () =>
      getTimeOffAdmin(teamMember?.locations[0]?.salon_id, teamMember?.id, {
        date_range: {
          from: dayjs(selectedDate).format("YYYY-MM-DD"),
          to: dayjs(selectedDate)
            .endOf("week")
            .add(1, "day")
            .format("YYYY-MM-DD"),
        },
      })
  );
  if (!locationId) {
    return null;
  }

  const modalComponents = {
    AddBreak: (
      <Modal width={600} visible={true} onCancel={closeModal} footer={null}>
        {typeof selectedShiftIdOrDate === "number" ? (
          <AddBreakForm
            locationId={+locationId}
            teamMemberId={teamMember?.id}
            shifts={formatedWorkingHours}
            breakIndex={1}
            handleDeleteBreak={() => {}}
            handleClose={closeModal}
            handleAddBreak={() => {}}
            index={1}
            selectedDate={selectedDay!}
            dayBreak={{
              teamMemberId: teamMember?.id,
              locationId: +locationId,
            }}
            config={{
              isAdmin: true,
              isEdit: false,
              salonId: teamMember?.locations[0]?.salon_id || undefined,
              shiftId: selectedShiftIdOrDate
                ? selectedShiftIdOrDate
                : undefined,
            }}
          />
        ) : null}
      </Modal>
    ),
    AddAdditionalShift:
      typeof selectedShiftIdOrDate === "string" ? (
        <AddAdditionalShift
          visible={true}
          onClose={closeModal}
          team_member_id={teamMember?.id}
          selectedDate={selectedDay}
          location_id={+locationId}
          config={{
            isAdmin: true,
            isEdit: false,
            date: selectedShiftIdOrDate ? selectedShiftIdOrDate : undefined,
          }}
        />
      ) : null,
    EditShifts: (
      <Main
        visible={true}
        onClose={closeModal}
        team_member_id={teamMember?.id}
        location_id={+locationId}
        selectedDate={selectedDate}
        config={{
          isAdmin: true,
          isEdit: true,
          workingHoursWithShifts: TeamMemberWorkingsHour?.data?.data,
        }}
      />
    ),
    AddShifts: (
      <Main
        visible={true}
        onClose={closeModal}
        team_member_id={teamMember?.id}
        location_id={+locationId}
        selectedDate={selectedDay}
        config={{
          isAdmin: true,
          isEdit: false,
        }}
      />
    ),
    DeleteWorkingShift: (
      <DeleteWorkingShift
        locationId={+locationId}
        teamMemberId={teamMember?.id}
        visible={true}
        onClose={closeModal}
        workingShiftId={selectedDate}
      />
    ),
    DeleteTimeOff: (
      <DeleteTimeOff
        visible={true}
        onClose={closeModal}
        timeOffId={selectedDate}
        teamMemberId={teamMember.id}
        locationId={+locationId}
      />
    ),
  };
  const renderModal = activeModal ? modalComponents[activeModal] : null;
  const isCurrentWeek = () => {
    const currentDate = dayjs(); // Today's date
    const startOfThisWeek = dayjs(selectedDate).format("YYYY-MM-DD"); // Start of this week, considering ISO week starts on Monday
    const endOfThisWeek = dayjs(selectedDate)
      .endOf("week")
      .add(1, "day")
      .format("YYYY-MM-DD"); // End of this week

    return (
      dayjs(currentDate).isSameOrAfter(startOfThisWeek) &&
      dayjs(currentDate).isSameOrBefore(endOfThisWeek)
    );
  };

  return (
    <div className="bg-white p-4 rounded-lg h-fit TeamMemberAdmin">
      {renderModal}
      <div className="flex items-center justify-between mb-4 ">
        <h3 className="text-color-primary text-xl font-semibold">
          Member working hours
        </h3>
        <div className="flex justify-end ">
          <Button
            disabled={!!!TeamMemberWorkingsHour?.data?.data?.id}
            type="text"
            htmlType="button"
            onClick={() => openModal("EditShifts", selectedDay)}
          >
            <CiEdit color="gray" size={20} />
          </Button>
          <Button
            type="text"
            htmlType="button"
            onClick={() => openModal("AddShifts", selectedDay)}
          >
            <MdAdd color="gray" size={20} />
          </Button>
        </div>
      </div>
      <div className="flex items-center justify-center border-none rounded-md bg-[#EEF0FF] w-full mb-2">
        <div className="w-fit flex items-center justify-center bg-[#EEF0FF]">
          <IoIosArrowBack
            className="cursor-pointer w-6 h-6 p-1 mx-1 text-[#75757E]"
            onClick={() => changeDate("prev")}
          />
          <span className="text-sm font-semibold text-color-primary">
            {isCurrentWeek() && "This Week"}
          </span>
          <DatePicker
            onChange={onChangeDatePicker}
            picker={"week"}
            value={dayjs(selectedDate)}
            popupClassName=""
            className={`flex items-center justify-center text-xs ${
              isCurrentWeek() ? "!w-[33%]" : "!w-[35%]"
            }`}
            allowClear={false}
            variant="borderless"
            format={(value) =>
              `${dayjs(value).startOf("week").format("MM/DD")} - ${dayjs(value)
                .endOf("week")
                .format("MM/DD")}`
            }
          />
          <span className="text-xs text-[#75757E]">
            {dayjs(selectedDate).format("MMM YYYY")}
          </span>
          <IoIosArrowForward
            className="cursor-pointer w-6 h-6 p-1 m-1 text-[#75757E]"
            onClick={() => changeDate("next")}
          />
        </div>
      </div>

      {isLoading ? (
        <Spin size="large" className="flex items-center justify-center" />
      ) : (
        <div className="flex flex-col items-start justify-start gap-4">
          {getDaysOfWeek(selectedDate)?.map((e: any, i) => {
            const matchingShift =
              TeamMemberWorkingsHour?.data?.data?.working_shifts?.find(
                (shift: any) =>
                  dayjs(shift?.date).format("dddd - DD MMM") ===
                  e.format("dddd - DD MMM")
              );
            // const isLocationClose = locationDetails?.opening_hours.map(
            //   (item: any) => {
            //     return (
            //       item.day.toLowerCase() === e.split(" - ")[0].toLowerCase()
            //     );
            //   }
            // );
            const isSalonLocationClosed = (date: string) => {
              let flag = false;
              SalonCLosePeriodDate?.forEach(
                (closedPeriod: {
                  id: number;
                  start_date: string;
                  end_date: string;
                  locations: any[];
                }) => {
                  if (
                    dayjs(date).isSame(dayjs(closedPeriod?.start_date)) ||
                    dayjs(date).isBetween(
                      dayjs(closedPeriod?.start_date),
                      dayjs(closedPeriod?.end_date)
                    ) ||
                    dayjs(date).isSame(dayjs(closedPeriod?.end_date))
                  ) {
                    flag = true;
                  } else {
                  }
                }
              );
              return flag;
            };
            const isSalonHasVacation = (date: string) => {
              let flag = false;
              GetTimeOffAdmin?.data?.forEach(
                (VacationPeriod: { id: number; date: string }) => {
                  if (
                    dayjs(date).isSame(
                      dayjs(VacationPeriod?.date).format("YYYY-MM-DD")
                    )
                  ) {
                    flag = true;
                  } else {
                  }
                }
              );
              return flag;
            };
            const newDate = dayjs(e).format("YYYY-MM-DD");
            console.log(isSalonHasVacation(newDate));
            return (
              <DayWorkingHours
                date={dayjs(e).format("dddd - DD MMM")}
                data={matchingShift || false}
                isLocationClose={isSalonLocationClosed(newDate)}
                isSalonHasVacation={isSalonHasVacation(newDate)}
                handleOpenModalToAddToShift={handleOpenModalToAddToShift}
                config={{
                  teamMemberId: teamMember?.id,
                  locationId: +locationId,
                }}
              />
            );
          })}
          <TeamMemberVacation
            data={teamMember}
            vacations={GetTimeOffAdmin?.data}
          />
        </div>
      )}
    </div>
  );
};

export default TeamMemberWorkingHours;
